import React from 'react';

const FilterIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.6328 14.75C21.6328 15.64 21.3928 16.48 20.9528 17.2C20.1328 18.57 18.6228 19.5 16.8828 19.5C15.9428 19.5 15.0628 19.22 14.3228 18.73C13.7028 18.35 13.1928 17.82 12.8228 17.2C12.3828 16.48 12.1328 15.64 12.1328 14.75C12.1328 12.13 14.2628 10 16.8828 10C17.2428 10 17.5928 10.04 17.9228 10.12C20.0528 10.59 21.6328 12.49 21.6328 14.75Z"
                stroke="#292D32"
                strokeWidth="1.8"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.0312 14.7501L16.2012 15.9201L18.7312 13.5801"
                stroke="#292D32"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.6925 4.01999V6.23999C20.6925 7.04999 20.1825 8.06001 19.6825 8.57001L17.9225 10.12C17.5925 10.04 17.2425 10 16.8825 10C14.2625 10 12.1325 12.13 12.1325 14.75C12.1325 15.64 12.3825 16.48 12.8225 17.2C13.1925 17.82 13.7025 18.35 14.3225 18.73V19.07C14.3225 19.68 13.9225 20.49 13.4125 20.79L12.0025 21.7C10.6925 22.51 8.8725 21.6 8.8725 19.98V14.63C8.8725 13.92 8.4625 13.01 8.0625 12.51L4.22247 8.47C3.72247 7.96 3.3125 7.05001 3.3125 6.45001V4.12C3.3125 2.91 4.22252 2 5.33252 2H18.6725C19.7825 2 20.6925 2.90999 20.6925 4.01999Z"
                stroke="#292D32"
                strokeWidth="1.8"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default FilterIcon;
